import {
    CircularProgress as MuiCircularProgress,
    type CircularProgressProps as MuiCircularProgressProps,
} from "@mui/material";

interface CircularProgressProps extends Omit<MuiCircularProgressProps, "color"> {
    size?: number;
    color?: MuiCircularProgressProps["color"];
}

export function CircularProgress({ size = 24, color = "primary", ...props }: CircularProgressProps) {
    return (
        <MuiCircularProgress
            size={size}
            color={color}
            sx={{
                color: "rgb(var(--color-primary))",
            }}
            {...props}
        />
    );
}
